/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurestatsdescription2Inputs */

const he_extension_featurestatsdescription2 = /** @type {(inputs: Extension_Featurestatsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר גבוה, נמוך וממוצע עם ניתוח מגמות מפורט`)
};

const en_extension_featurestatsdescription2 = /** @type {(inputs: Extension_Featurestatsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High, low, and average prices with detailed trend analysis`)
};

/**
* | output |
* | --- |
* | "High, low, and average prices with detailed trend analysis" |
*
* @param {Extension_Featurestatsdescription2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurestatsdescription2 = /** @type {((inputs?: Extension_Featurestatsdescription2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurestatsdescription2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurestatsdescription2(inputs)
	return en_extension_featurestatsdescription2(inputs)
});
export { extension_featurestatsdescription2 as "extension_featureStatsDescription" }